// @flow
import * as React from 'react';
import withAnalytics from 'shared/hoc/withAnalytics';
import ErrorMessageBlock from './ErrorMessageBlock';

type Props = {
  widgetId: string,
  children: React.Element<any> | React.Element<any>[]
}

type State = {
  hasError: boolean
}

// Hides the component on error
class ErrorBoundary extends React.Component<Props, State> {
  state = {
    hasError: false
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, errorMessage: error.toString() };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    const { widgetId } = this.props;

    console.error(error);
    console.log(info);

    this.props.analytics.trackUIEventError('Genesis Error', `${error.message} [${widgetId}] [${info.componentStack}]`);
  }

  render() {
    const { children, isEditor } = this.props;
    const { hasError, errorMessage } = this.state;

    if (hasError) {
      return isEditor ? <ErrorMessageBlock errorMessage={errorMessage} /> : null;
    }

    return children;
  }
}

export default withAnalytics(ErrorBoundary);
